<!-- 销售退货收货模板 -->
<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog  title="销售退货收货申请单"  :visible.sync="dialogVisible" top="2rem" center  width="90%" append-to-body>
			<div class='components_content_box'>
				<div class="page_content_top">
					<div class="page_content_top_line">
						<el-form :inline="true" :model="getRequestData" class="demo-form-inline" v-if="pageShowData[0]" size="mini">
							<el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in pageShowData[0].jurconfigform" :key="formOneKey">
								
								<!-- 退回单位	 -->
								<el-input v-if="formOneValue.entityField == 'rgamRapcus'" v-model.trim="getRequestData.cmName" clearable 
									@focus="$refs['showSelectData'].openBox('customerList','customerList','cmId')">
								</el-input>
								
								<el-input v-else  v-model.trim="getRequestData[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
								
							</el-form-item>
							
							<el-form-item>
								<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div class="page_content_center">
					<el-table  v-if="pageShowData[1]" stripe :data="returnData.list" @row-dblclick="selectDataAction"   min-height="450px" border style="width: 100%" highlight-current-row>
						<el-table-column type="expand" label="其它信息"  width="100">
						    <template slot-scope="props">
								<el-tabs type="border-card">
									<el-tab-pane v-if="pageShowData[2]" :label="pageShowData[2].jciName">
										
										<el-table :data="[props.row.desuRgapplySupInfo]"  border style="width: 100%">
											<el-table-column
												v-if="tableValye.isShow==1" 
												v-for="(tableValye,tableKey) in pageShowData[2].jurconfigtable" 
												:key="tableKey" 
												:prop="tableValye.entityField"  
												:label="tableValye.showField"  >
											</el-table-column>
										</el-table>
									</el-tab-pane>
									<el-tab-pane v-if="pageShowData[3]" :label="pageShowData[3].jciName">
										<el-table  :data="props.row.desuRgregoDetailVos"  border  style="width: 100%">
											<el-table-column
												v-if="tableValye.isShow==1" 
												v-for="(tableValye,tableKey) in pageShowData[3].jurconfigtable" 
												:key="tableKey" 
												:prop="tableValye.entityField"  
												:label="tableValye.showField"  >
												<template  slot-scope="scope">
													<div v-if="tableValye.entityField == 'rgadEffdate'">
														<div v-if="scope.row[tableValye.entityField]">
															{{$common.getLocalTime(scope.row[tableValye.entityField])}}
														</div>
													</div>
													<div v-else-if="tableValye.entityField == 'rgadProdate'">
														<div v-if="scope.row[tableValye.entityField]">
															{{$common.getLocalTime(scope.row[tableValye.entityField])}}
														</div>
													</div>
													<div v-else>
														{{scope.row[tableValye.entityField]}}
													</div>
												</template>
											</el-table-column>
										</el-table>
									</el-tab-pane>
									
									
								</el-tabs>
						    </template>
						</el-table-column>
						<el-table-column v-if="tableValye.isShow==1"
							v-for="(tableValye,tableKey) in pageShowData[1].jurconfigtable" 
							:key="tableKey" 
							:prop="tableValye.entityField"  
							:label="tableValye.showField">
							<template  slot-scope="scope">
								<div v-if="tableValye.entityField == 'rgamRapdate'">
									<div v-if="scope.row[tableValye.entityField]">
										{{$common.getLocalTime(scope.row[tableValye.entityField])}}
									</div>
								</div>
								<div v-else>
									{{scope.row[tableValye.entityField]}}
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="page_content_bottom">
					<el-pagination
						background
						@size-change="setDataPageSize"
						@current-change="setDataPageNumber"
						:current-page="getRequestData.page"
						:page-sizes="[30,50,100,500]"
						:page-size="30"
						layout="total, sizes, prev, pager, next, jumper"
						:total="returnData.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	name:'salesReturnReceivingTemplate',
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			dialogVisible:false,
			getRequestData:{
				rgamRapcus:"",
				cmName:'', // 客户名称
				page:1,
				rows:30,
				start:'',
				end:'',
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			pageShowData:[],
			userOneList:[],
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		'getRequestData.cmName':{
			handler:function(newValue,oldValue){
				if(newValue==''){
					this.getRequestData.rgamRapcus = ''
				}
			},
			deep:true,
		}
	},
	//方法集合
	methods: {
		// 获取业务员
		async getSpecialUser(){
			let responseData =  await this.$http.getSpecialUser({opmSalesperson:1})
			if(responseData.status == 200){
				this.userOneList = responseData.result
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		selectDataAction(row, column, event){
			this.dialogVisible = false
			this.$parent.extractData(row)
		},
		
		isShowData(name,value){
			switch(name){
				case 'customerList':
					var dataInfo = sessionStorage.getItem('selectCustomerData')
					if(dataInfo){
						dataInfo = JSON.parse(dataInfo)
						this.getRequestData.rgamRapcus = dataInfo.cmId
						this.getRequestData.cmName = dataInfo.cmName
					}
					
				break;
				
				default:
					this.getRequestData[name] = value
				
			}
		},
		openBox(){
			this.getPageInfo()
			this.getDataList()
			this.dialogVisible = true
		},
		sendAction(data){
			this.dialogVisible = false
			this.$parent.viewCopy(data)
		},
		// 获取数据列表
		async getPageInfo(){
			var pathId = parent.getMenuInfo('/salesReceivingList')
			let responseData =  await this.$http.pageFormText({ids:[pathId.jurId]})
			if(responseData.status == 200){
				this.pageShowData = responseData.result
				console.log(responseData.result)
			
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		selecDataAction(data){
			this.selectedDataList =  data
		},
		
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getSalesReturnReceivingYesList(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getSpecialUser()
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.table_content_tag{
	margin-right: 1rem;
}
.el-tabs--border-card_new{
	height: 85vh;
	overflow-y: scroll;
}
</style>
